import { render, staticRenderFns } from "./stream5.vue?vue&type=template&id=5ebbd2a0&"
import script from "./stream5.vue?vue&type=script&lang=js&"
export * from "./stream5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports